import { Switch, Route, Redirect } from "react-router-dom";

import Header from "./components/Header/Header";
import FooterV2 from "./components/FooterV2/FooterV2";

import Home from "./pages/Home/Home";
import ProductListing from "./pages/ProductListing/ProductListing";
import AboutUsTheCompany from "./pages/AboutUsTheCompany/AboutUsTheCompany";
import AboutUsTheCompanyV2 from "./pages/AboutUsTheCompanyV2/AboutUsTheCompany";
import AboutUsOurJourney from "./pages/AboutUsOurJourney/AboutUsOurJourney";
import AboutUsManagement from "./pages/AboutUsManagement/AboutUsManagement";
import OurSetupInfrastructure from "./pages/OurSetupInfrastructure/OurSetupInfrastructure";
import OurSetupTechnology from "./pages/OurSetupTechnology/OurSetupTechnology";
import OurSetupCertifications from "./pages/OurSetupCertifications/OurSetupCertifications";
import OurSetupQualityAndRnD from "./pages/OurSetupQualityAndRnD/OurSetupQualityAndRnD";
import Newsroom from "./pages/Newsroom/Newsroom";
import OurSales from "./pages/OurSales/OurSales";
import InvestorRelations from "./pages/InvestorRelations/InvestorRelations";
import ESG from "./pages/ESG/ESG";
import ProductsInner from "./pages/ProductsInner/ProductsInner";
import ProductsPopup from "./components/ProductsPopup/ProductsPopup";
import { useEffect, useState } from "react";
import Loader from "./components/Loader/Loader";
import PolyesterYarn from "./pages/ProductsInner/Polyester/Polyester";
import TechnicalYarn from "./pages/ProductsInner/Technical/Technical";
import Revir from "./pages/ProductsInner/Revir/Revir";
import Borndyed from "./pages/ProductsInner/Borndyed/Borndyed";
import Functional from "./pages/ProductsInner/Functional/Functional";
import Customised from "./pages/ProductsInner/Customised/Customised";
import Ouryarn from "./pages/OurYarnsLanding/Ouryarnslanding";
import Careers from "./components/Careers/Careers";
import OurInformation from "./pages/OurInformation/OurInformation";
import ContactUs from "./pages/ContactUs/ContactUs";
import Blogs from "./pages/Blog/Blog";
import BlogInner from "./pages/BlogInner/BlogInner";
import BlogInner2 from "./pages/BlogInner2/BlogInner2";
import BlogInner3 from "./pages/BlogInner3/BlogInner3";
import BlogInner4 from "./pages/BlogInner4/BlogInner4";
import BlogInner5 from "./pages/BlogInner5/BlogInner5";
import BlogInner6 from "./pages/BlogInner6/BlogInner6";
import BlogInner7 from "./pages/BlogInner7/BlogInner7";
import DryCool from "./pages/ProductsInner/DryCool/DryCool";
import BlogInner8 from "./pages/BlogInner8/BlogInner8";
import {
  blog10innerURL,
  blog11innerURL,
  blog12innerURL,
  blog13innerURL,
  blog14innerURL,
  blog15innerURL,
  blog16innerURL,
  blog17innerURL,
  blog18innerURL,
  blog19innerURL,
  blog20innerURL,
  blog21innerURL,
  blog22innerURL,
  blog23innerURL,
  blog24innerURL,
  blog25innerURL,
  blog26innerURL,
  blog9innerURL,
} from "./helpers/paths";
import BlogInner9 from "./pages/BlogInner9/BlogInner9";
import BlogInner10 from "./pages/BlogInner10/BlogInner10";
import SFlex from "./pages/ProductsInner/SFlex/SFlex";
import CDP from "./pages/ProductsInner/CDP/CDP";
import CorporateGovernance from "./pages/CorporateGovernance/CorporateGovernance";
import FinancialPerformance from "./pages/FinancialPerformance/FinancialPerformance";
import AnnualReports from "./pages/AnnualReports/AnnualReports";
import Announcements from "./pages/Announcements/Announcements";
import ShareholdingPattern from "./pages/ShareholdingPattern/ShareholdingPattern";
import IntimationOfInvestorMeet from "./pages/IntimationOfInvestorMeet/IntimationOfInvestorMeet";
import InvestorContacts from "./pages/InvestorContacts/InvestorContacts";
import Disclosures from "./pages/Disclosures/Disclosures";
import InvestorRelationsV2 from "./pages/InvestorRelationsV2/InvestorRelationsV2";
import BlogInner11 from "./pages/BlogInner11/BlogInner11";
import BlogInner12 from "./pages/BlogInner12/BlogInner12";
import BlogInner13 from "./pages/BlogInner13/BlogInner13";
import BlogInner14 from "./pages/BlogInner14/BlogInner14";
import BlogInner15 from "./pages/BlogInner15/BlogInner15";
import StrechYarn from "./pages/ProductsInner/StrechYarn/StrechYarn";
import BlogInner16 from "./pages/BlogInner16/BlogInner16";
import BlogInner17 from "./pages/BlogInner17/BlogInner17";
import ContactUsV2 from "./pages/ContactUsV2/ContactUsV2";
import BlogInner18 from "./pages/BlogInner18/BlogInner18";
import CSR from "./pages/CSR/CSR";
import BlogInner19 from "./pages/BlogInner19/BlogInner19";
import BlogInner20 from "./pages/BlogInner20/BlogInner20";
import BlogInner21 from "./pages/BlogInner21/BlogInner21";
import BlogInner22 from "./pages/BlogInner22/BlogInner22";
import AboutUsOurValues from "./pages/AboutUsOurValues/AboutUsOurValues";
import BlogInner23 from "./pages/BlogInner23/BlogInner23";
import BlogInner24 from "./pages/BlogInner24/BlogInner24";
import BlogInner25 from "./pages/BlogInner25/BlogInner25";
import BlogInner26 from "./pages/BlogInner26/BlogInner26";
// import OurSetupCertificationsSanathanTextiles from "./pages/OurSetupCertificationsSanathanTextiles/OurSetupCertificationsSanathanTextiles";
// import OurSetupCertificationsSanathanPolycot from "./pages/OurSetupCertificationsSanathanPolycot/OurSetupCertificationsSanathanPolycot";

const Routing = () => {
  const [isLoading, setLoading] = useState(true);

  function fakeRequest() {
    return new Promise((resolve) => setTimeout(() => resolve(), 0));
  }

  useEffect(() => {
    fakeRequest().then(() => {
      const el = document.querySelector("#root");
      if (el) {
        //   el.remove();
        setLoading(!isLoading);
      }
    });
  }, []);

  return isLoading ? (
    <Loader />
  ) : (
    <>
      <Header />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/products" component={ProductListing} />
        {/* <Route exact path="/contact-us" component={ContactUs} /> */}
        <Route
          exact
          path="/about-us/the-company"
          component={AboutUsTheCompanyV2}
          // component={AboutUsTheCompany}
        />
        <Route exact path="/about-us/our-values" component={AboutUsOurValues} />
        <Route
          exact
          path="/about-us/our-journey"
          component={AboutUsOurJourney}
        />
        <Route exact path="/about-us/our-team" component={AboutUsManagement} />
        <Route
          exact
          path="/our-setup/infrastructure"
          component={OurSetupInfrastructure}
        />
        <Route
          exact
          path="/our-setup/tech-in-textile"
          component={OurSetupTechnology}
        />
        <Route
          exact
          path="/our-setup/certifications"
          component={OurSetupCertifications}
        />
        <Route
          exact
          path="/our-setup/quality-and-r+d"
          component={OurSetupQualityAndRnD}
        />
        <Route exact path="/ouryarn-in-your-life" component={Ouryarn} />
        <Route exact path="/newsroom" component={Newsroom} />
        <Route exact path="/our-sales" component={OurSales} />
        {/* <Route exact path="/investor-relations" component={InvestorRelations} /> */}
        <Route
          exact
          path="/investor-relations"
          component={InvestorRelationsV2}
        />
        <Route
          exact
          path="/investor-relations/corporate-governance"
          component={CorporateGovernance}
        />
        <Route
          exact
          path="/investor-relations/financial-performance"
          component={FinancialPerformance}
        />
        <Route
          exact
          path="/investor-relations/annual-reports"
          component={AnnualReports}
        />
        <Route
          exact
          path="/investor-relations/announcements"
          component={Announcements}
        />
        <Route
          exact
          path="/investor-relations/shareholding-pattern"
          component={ShareholdingPattern}
        />
        <Route
          exact
          path="/investor-relations/investor-meet-presentation"
          component={IntimationOfInvestorMeet}
        />
        <Route
          exact
          path="/investor-relations/investor-contacts"
          component={InvestorContacts}
        />
        <Route
          exact
          path="/investor-relations/disclosures-under-regulation-46-and-62-of-sebi-lodr-regulations-2015"
          component={Disclosures}
        />
        <Route exact path="/esg" component={ESG} />
        {/* <Route exact path="/thankyou" component={Thankyou} /> */}
        <Route exact path="/products/cotton-yarn" component={ProductsInner} />
        <Route
          exact
          path="/products/polyester-yarn"
          component={PolyesterYarn}
        />
        <Route
          exact
          path="/products/yarn-for-technical-textile"
          component={TechnicalYarn}
        />
        <Route exact path="/products/reviro" component={Revir} />
        <Route exact path="/products/born-dyed" component={Borndyed} />
        <Route exact path="/products/dry-cool" component={DryCool} />
        <Route exact path="/products/stretch-yarn" component={StrechYarn} />
        <Route exact path="/products/s-flex" component={SFlex} />
        <Route
          exact
          path="/products/cationic-dyeable-polyester"
          component={CDP}
        />
        {/* <Route exact path="/products/functional-yarn" component={Functional} /> */}
        {/* <Route exact path="/products/customised-yarn" component={Customised} /> */}

        {/* <Route exact path="/products/popup" component={ProductsPopup} /> */}
        <Route exact path="/blogs" component={Blogs} />
        <Route exact path="/blogs/recycled-pet-chip" component={BlogInner} />
        <Route
          exact
          path="/blogs/development-yarn-fibers"
          component={BlogInner2}
        />
        <Route exact path="/blogs/technical-textiles" component={BlogInner3} />
        <Route
          exact
          path="/blogs/re-weaving-indias-success-story"
          component={BlogInner4}
        />

        <Route
          exact
          path="/blogs/polyester-yarn-market-in-india"
          component={BlogInner5}
        />
        <Route exact path="/blogs/types-of-yarn" component={BlogInner6} />
        <Route
          exact
          path="/blogs/technical-textile-innovations"
          component={BlogInner7}
        />
        <Route
          exact
          path="/blogs/craft-your-festive-wardrobe-with-sanathan-textile-yarns-for-blazers-suits-kurtas-and-sarees"
          component={BlogInner8}
        />
        <Route exact path={blog9innerURL} component={BlogInner9} />
        <Route exact path={blog10innerURL} component={BlogInner10} />
        <Route exact path={blog11innerURL} component={BlogInner11} />
        <Route exact path={blog12innerURL} component={BlogInner12} />
        <Route exact path={blog13innerURL} component={BlogInner13} />
        <Route exact path={blog14innerURL} component={BlogInner14} />
        <Route exact path={blog15innerURL} component={BlogInner15} />
        <Route exact path={blog16innerURL} component={BlogInner16} />
        <Route exact path={blog17innerURL} component={BlogInner17} />
        <Route exact path={blog18innerURL} component={BlogInner18} />
        <Route exact path={blog19innerURL} component={BlogInner19} />
        <Route exact path={blog20innerURL} component={BlogInner20} />
        <Route exact path={blog21innerURL} component={BlogInner21} />
        <Route exact path={blog22innerURL} component={BlogInner22} />
        <Route exact path={blog23innerURL} component={BlogInner23} />
        <Route exact path={blog24innerURL} component={BlogInner24} />
        <Route exact path={blog25innerURL} component={BlogInner25} />
        <Route exact path={blog26innerURL} component={BlogInner26} />

        <Route exact path="/career" component={Careers} />
        <Route exact path="/Other-Information.php" component={OurInformation} />
        <Route exact path="/contact-us" component={ContactUsV2} />
        <Route exact path="/csr" component={CSR} />

        {/* <Route
          exact
          path="/our-setup/certifications/sanathan-textiles"
          component={OurSetupCertificationsSanathanTextiles}
        />
        <Route
          exact
          path="/our-setup/certifications/sanathan-polycot"
          component={OurSetupCertificationsSanathanPolycot}
        /> */}

        <Redirect to="/"></Redirect>
      </Switch>
      <FooterV2 />
    </>
  );
};

export default Routing;
